import React from "react";
import PermissionGate from "~/components/PermissionGate";
import CustomeButton from "~/components/Button";
import PropTypes from "prop-types";

const EmptyDataView = ({
  Icon,
  Header,
  Description,
  setModalVisible,
  entityId,
}) => {
  return (
    <div className="flex flex-column justify-content-center align-items-center p-5 empty__data__view">
      {Icon && <div className="empty__data__view--icon m-0">{Icon}</div>}
      {Header && <p className="empty__data__view--header">{Header}</p>}
      <PermissionGate
        resource="shareholder"
        action="modify"
        resourceAttr={{ entity_id: entityId }}
      >
        {Description && (
          <p className="empty__data__view--description">{Description}</p>
        )}
        <CustomeButton
          label="Add Share Transaction"
          className="access-btn"
          icon="pi pi-plus"
          iconPos="right"
          onClick={() => setModalVisible(true)}
        />
      </PermissionGate>
    </div>
  );
};
EmptyDataView.proptypes = {
  Icon: PropTypes.node,
  Header: PropTypes.string,
  Description: PropTypes.string,
  setModalVisible: PropTypes.func,
  entityId: PropTypes.string,
};

export default EmptyDataView;
